import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { T, t } from '@sm/intl';
import { useMutation, useLazyQuery } from '@apollo/client';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { IconFolderArrow } from '@wds/icons';
import useInterval from '../../shared/useInterval';
import ToastPending from './ToastPending';
import ToastError from './ToastError';
import { createOECQuestionResponseExport } from '../../graph/createExportJob';
import { oecExportJobQuery } from '../../graph/queryExportJob';
export const COPY = {
  button: {
    id: 'OpenEndedCoding.Export.button',
    defaultMessage: 'Export',
    description: '[Type: Header][Vis: med] - Button to export data'
  },
  iconFolderArrow: {
    id: 'OpenEndedCoding.Export.iconFolderArrow',
    defaultMessage: 'Folder arrow icon',
    description: '[Type: Label][Vis: low] - Icon to indicate the export will download content locally'
  }
};
var EXPORT_JOB_STATUS;
(function (EXPORT_JOB_STATUS) {
  EXPORT_JOB_STATUS["SERVER_ERROR"] = "SERVER_ERROR";
  EXPORT_JOB_STATUS["ENQUEUED"] = "ENQUEUED";
  EXPORT_JOB_STATUS["STARTED"] = "STARTED";
  EXPORT_JOB_STATUS["SUCCESS"] = "SUCCESS";
})(EXPORT_JOB_STATUS || (EXPORT_JOB_STATUS = {}));
const FETCH_JOBS_INTERVAL = 10000;
const ExportButton = ({
  surveyId,
  questionId,
  respondentCount
}) => {
  const [disabled, setDisabled] = useState(false);
  const [preparingExport, setPreparingExport] = useState(false);
  const [exportError, setExportError] = useState(false);
  const [exportJobId, setExportJobId] = useState(null);
  // Queries
  const [queryExportJobStatus] = useLazyQuery(oecExportJobQuery, {
    variables: {
      surveyId,
      id: exportJobId
    },
    fetchPolicy: 'no-cache',
    onCompleted: ({
      analysisExportJob: {
        id,
        status,
        file
      }
    }) => {
      if (status === EXPORT_JOB_STATUS.SUCCESS && (file === null || file === void 0 ? void 0 : file.downloadLink)) {
        window.location.href = file === null || file === void 0 ? void 0 : file.downloadLink;
        setDisabled(false);
        setPreparingExport(false);
      } else if (status === EXPORT_JOB_STATUS.SERVER_ERROR) {
        setPreparingExport(false);
        setExportError(true);
        setDisabled(false);
      }
    },
    onError: () => {}
  });
  // Mutations
  const [createOECExport] = useMutation(createOECQuestionResponseExport, {
    onCompleted: ({
      createOECQuestionResponseExport: {
        id,
        status
      }
    }) => {
      if (status === EXPORT_JOB_STATUS.ENQUEUED) {
        setExportJobId(id);
        setPreparingExport(true);
      } else if (status === EXPORT_JOB_STATUS.SERVER_ERROR) {
        setDisabled(false);
        setPreparingExport(false);
        setExportError(true);
      }
    },
    onError: () => {
      setDisabled(false);
      setPreparingExport(false);
      setExportError(true);
    }
  });
  useInterval(() => {
    if (!preparingExport) {
      return;
    }
    queryExportJobStatus({
      variables: {
        surveyId,
        id: exportJobId
      }
    });
  }, preparingExport ? FETCH_JOBS_INTERVAL : 0);
  const startExport = () => {
    setDisabled(true);
    setPreparingExport(true);
    void createOECExport({
      variables: {
        surveyId,
        questionId,
        respondentCount
      }
    });
  };
  return _jsxs(_Fragment, {
    children: [_jsx(Button, {
      color: "muted",
      disabled: disabled,
      onClick: startExport,
      marginWidth: 1,
      children: _jsxs(Box, {
        display: "flex",
        alignItems: "center",
        children: [_jsx(Box, {
          mr: 3,
          mb: 1,
          children: _jsx(IconFolderArrow, {
            title: t(COPY.iconFolderArrow),
            size: "md"
          })
        }), _jsx(T, {
          desc: COPY.button
        })]
      })
    }), preparingExport && _jsx(ToastPending, {}), exportError && _jsx(ToastError, {})]
  });
};
export default ExportButton;